import { AppBar, Box, Button, Grow, Tab, Tabs } from '@mui/material'
import { FC, useState } from 'react'
import { connect } from 'react-redux'
import {
  RoleType,
  actions as appActions,
  saveBackup,
} from '../../redux/appReducer'
import { StateType } from '../../redux/store'
import { TabPanel } from '../AppTabs'
import CategoriesTab from './Category/CategoriesTab'
import ConfigsTab from './Configs/ConfigsTab'
import MarkupTab from './Markup/MarkupTab'
import DiscountTiersTab from './DiscountTiers/DiscountTiersTab'
import { EnqueueSnackbarType, Flex } from '../common/Helpers'
import { useSnackbar } from 'notistack'

interface IProps {
  activeTab: number
  userEmail: string
  role: RoleType

  setActiveTab(value: number): void
  saveBackup(enqueueSnackbar: EnqueueSnackbarType): void
}

const superAdmins = [
  'Manvelarz@gmail.com',
  'troyg@greenbergcustomcabinets.com',
  'xgagik8@gmail.com',
]
const AdminTab: FC<IProps> = (props) => {
  const { enqueueSnackbar } = useSnackbar()

  const [isBackupDisabled, setIsBackupDisabled] = useState(false)

  const handleBackupClick = async () => {
    setIsBackupDisabled(true)
    await props.saveBackup(enqueueSnackbar)
    setIsBackupDisabled(false)
  }

  return (
    <Box>
      <AppBar position="static" color="default">
        <Flex
          centerY
          sx={{
            justifyContent: 'space-between',
          }}
        >
          <Tabs
            value={props.activeTab}
            onChange={(e, newValue) => props.setActiveTab(newValue)}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab label="Categories" value={0} />
            <Tab label="Markups" value={1} />
            <Tab label="Configs" value={2} />
            <Tab label="Discount Tiers" value={3} />
          </Tabs>

          {superAdmins.includes(props.userEmail) ? (
            <Button
              sx={{ height: 40, mr: 2 }}
              variant="contained"
              onClick={handleBackupClick}
              disabled={isBackupDisabled}
            >
              Deploy to production
            </Button>
          ) : (
            <></>
          )}
        </Flex>
      </AppBar>

      <TabPanel value={props.activeTab} index={0}>
        <CategoriesTab />
      </TabPanel>
      <TabPanel value={props.activeTab} index={1}>
        <MarkupTab />
      </TabPanel>

      <TabPanel value={props.activeTab} index={2}>
        <ConfigsTab />
      </TabPanel>

      <TabPanel value={props.activeTab} index={3}>
        <DiscountTiersTab />
      </TabPanel>
    </Box>
  )
}

const mapStateToProps = (state: StateType) => ({
  activeTab: state.appReducer.activeAdminTab,
  userEmail: state.appReducer.user?.email || '',
  role: state.appReducer.user?.role || 'none',
})

export default connect(mapStateToProps, {
  setActiveTab: appActions.setAdminActiveTab,
  saveBackup,
})(AdminTab)
